export default "__VITE_ASSET__C_zifu9v__"